// extracted by mini-css-extract-plugin
module.exports = {"container":"Alien_container__1qLwa","image":"Alien_image__kAo64","name":"Alien_name__1KrcZ","description":"Alien_description__34hVC"};